import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const sendSmsToAll = async (message, password) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/send-sms-to-all/${password}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify({ message: message }),
  });
  const data = await response.json();
  return data;
};

export { sendSmsToAll };
